import {Injectable} from '@angular/core';
import {PlatformConfigurationService} from './platform-configuration.service';
import {LocalStorageService} from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private platformConfigurationService: PlatformConfigurationService,
              private localStorageService: LocalStorageService) {
  }

  public sendTokensToOtherAppsAndOpenProfile() {
    this.platformConfigurationService.subscribeForPortalConfiguration().subscribe(configuration => {
      const iframeAcademie = document.getElementsByTagName('iframe')[0].contentWindow;
      const iframeMagazine = document.getElementsByTagName('iframe')[1].contentWindow;
      document.getElementsByTagName('iframe')[0].src = configuration.academieUrl + '/';
      document.getElementsByTagName('iframe')[1].src = configuration.magazineUrl + '/';
      const token = localStorage.getItem('token');
      const roles = localStorage.getItem('roles');
      setTimeout(() => {
        iframeAcademie.postMessage(JSON.stringify({
          key: 'token',
          data: token
        }), configuration.academieUrl);
        iframeAcademie.postMessage(JSON.stringify({
          key: 'roles',
          data: roles
        }), configuration.academieUrl);
        iframeMagazine.postMessage(JSON.stringify({
          key: 'token',
          data: token
        }), configuration.magazineUrl);
        iframeMagazine.postMessage(JSON.stringify({
          key: 'roles',
          data: roles
        }), configuration.magazineUrl);
      }, 1000);
      setTimeout(() => {
        this.localStorageService.clearConfig();
        window.open(configuration.platformUrl + '/account/profile', '_self');
      }, 2000);
    })
  }

  public sendDeleteTokensAndOpenLogin() {
    this.sendLogoutToOtherApps();
    setTimeout(() => {
      this.platformConfigurationService.subscribeForPortalConfiguration().subscribe(() => {
        this.localStorageService.clearConfig();
        window.location.href = window.location.origin + '/api/sso-logout';
      })
    }, 3000)
  }

  private sendLogoutToOtherApps() {
    this.platformConfigurationService.subscribeForPortalConfiguration().subscribe(configuration => {
      const iframeAcademie = document.getElementsByTagName('iframe')[0].contentWindow;
      const iframeMagazine = document.getElementsByTagName('iframe')[1].contentWindow;
      document.getElementsByTagName('iframe')[0].src = configuration.academieUrl + '/';
      document.getElementsByTagName('iframe')[1].src = configuration.magazineUrl + '/';
      setTimeout(() => {
        iframeAcademie.postMessage(JSON.stringify({
          key: 'delete-authorization',
          data: null
        }), configuration.academieUrl);
        iframeMagazine.postMessage(JSON.stringify({
          key: 'delete-authorization',
          data: null
        }), configuration.magazineUrl);
      }, 500)
    })
  }

}
